import React from 'react';

const DynamicSchema = ({ weatherData, typhoonData }) => {
  // 1. LocalBusiness / WeatherStation Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Iligan Weather Monitoring Center",
    "image": "https://weather.goiligan.com/og-image.jpg",
    "@id": "https://weather.goiligan.com/#station",
    "url": "https://weather.goiligan.com/",
    "telephone": "+63-63-221-4078",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Buhanginan Hill, Pala-o",
      "addressLocality": "Iligan City",
      "addressRegion": "Lanao del Norte",
      "postalCode": "9200",
      "addressCountry": "PH"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 8.2280,
      "longitude": 124.2452
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    }
  };

  // 2. WeatherForecast Schema
  const forecastSchema = {
    "@context": "https://schema.org",
    "@type": "WeatherForecast",
    "name": `Weather Forecast for Iligan City - ${new Date().toLocaleDateString()}`,
    "url": "https://weather.goiligan.com/",
    "datePublished": new Date().toISOString(),
    "contentLocation": {
      "@type": "City",
      "name": "Iligan City"
    }
  };

  // 3. SpecialAnnouncement (Emergency Alert) Schema
  // This is used for Typhoons and Emergency Alerts
  let emergencyAlertSchema = null;
  if (typhoonData) {
    emergencyAlertSchema = {
      "@context": "https://schema.org",
      "@type": "SpecialAnnouncement",
      "name": `TYPHOON ALERT: ${typhoonData.localName}`,
      "text": `Active Typhoon "${typhoonData.localName}" affecting Northern Mindanao. Max winds ${typhoonData.maxWinds} kph. Follow Iligan DRRMO protocols.`,
      "category": "Emergency",
      "datePosted": new Date().toISOString(),
      "expires": new Date(Date.now() + 86400000).toISOString(), // 24h from now
      "announcementLocation": {
        "@type": "AdministrativeArea",
        "name": "Iligan City"
      },
      "governmentBenefitsInfo": {
        "@type": "GovernmentService",
        "name": "Iligan DRRMO Emergency Response",
        "serviceType": "Emergency Service",
        "provider": {
          "@type": "GovernmentOrganization",
          "name": "Iligan City Government"
        }
      }
    };
  }

  // 4. BreadcrumbList Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Philippines",
      "item": "https://weather.goiligan.com/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "Northern Mindanao",
      "item": "https://weather.goiligan.com/"
    }, {
      "@type": "ListItem",
      "position": 3,
      "name": "Iligan City",
      "item": "https://weather.goiligan.com/"
    }]
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(forecastSchema)}
      </script>
      {emergencyAlertSchema && (
        <script type="application/ld+json">
          {JSON.stringify(emergencyAlertSchema)}
        </script>
      )}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </>
  );
};

export default DynamicSchema;